// Initialize variables ABC
// let coords = [47.763333, 12.654444]; Standard Ruhpolding
// let coords = [47.682585, 12.695361] //Sonntagshorn
// let coords = [47.41264, 10.98321] //Zugspitze

// ============================================
// GEO-BASED COORDS - Berg nach Land des Users
// Priorität: Cookie > testgeo > Auto-Detection > Default
// ============================================

// TEST-OVERRIDE: ?testgeo=FR in URL
const urlParams = new URLSearchParams(window.location.search);
const testGeo = urlParams.get('testgeo')?.toUpperCase();

// Cookie lesen
function getAwCookie() {
  const nameEQ = 'aw_country=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length);
    }
  }
  return null;
}

const MOUNTAIN_MAP = {
  'DE': [47.4211, 10.9853],      // Zugspitze
  'AT': [47.0742, 12.6947],      // Großglockner
  'CH': [45.9766, 7.6585],       // Matterhorn
  'FR': [45.8326, 6.8652],       // Mont Blanc
  'IT': [46.5090, 10.5448],      // Ortler
  'NL': [47.1275, 10.2637],      // St. Anton am Arlberg
  'BE': [45.9766, 7.6585],       // Matterhorn
  'ES': [42.6312, 0.6566],       // Pico de Aneto
  'PL': [49.1794, 20.0881],      // Rysy (Hohe Tatra)
  'US': [43.7412, -110.8024],    // Grand Teton
  'CA': [51.4254, -116.1773],    // Lake Louise, Canadian Rockies
  'GB': [53.0685, -4.0763],      // Snowdon
  'IE': [51.9990, -9.7387],      // Carrauntoohil
  'SE': [67.9035, 18.5210],      // Kebnekaise
  'NO': [61.6365, 8.3125],       // Galdhøpiggen
  'DK': [45.9766, 7.6585],       // Matterhorn
  'FI': [67.9035, 18.5210],      // Kebnekaise
  'PT': [40.3220, -7.6116],      // Serra da Estrela
  'CZ': [50.7359, 15.7398],      // Sněžka
  'SK': [49.1646, 20.1348],      // Gerlachovský štít (Hohe Tatra)
  'SI': [46.3787, 13.8365],      // Triglav
  'HR': [43.3580, 16.4800],      // Biokovo
  'HU': [47.0742, 12.6947],      // Großglockner
  'RO': [45.6030, 24.6160],      // Făgăraș (Moldoveanu)
};

// Priorität: Cookie > testgeo > AlpenWerk.geo > Default
let coords;
const cookieCountry = getAwCookie();

if (cookieCountry && MOUNTAIN_MAP[cookieCountry]) {
  coords = MOUNTAIN_MAP[cookieCountry];
  console.log('[Leaflet] Cookie:', cookieCountry);
} else if (testGeo && MOUNTAIN_MAP[testGeo]) {
  coords = MOUNTAIN_MAP[testGeo];
  console.log('[Leaflet] Test:', testGeo);
} else if (window.AlpenWerk?.geo?.country && MOUNTAIN_MAP[window.AlpenWerk.geo.country]) {
  coords = MOUNTAIN_MAP[window.AlpenWerk.geo.country];
  console.log('[Leaflet] Auto:', window.AlpenWerk.geo.country);
} else {
  coords = [47.41264, 10.98321]; // Default: Zugspitze
  console.log('[Leaflet] Default: Zugspitze');
}
// ============================================



let north, east, south, west;

const MAP_SELECTION_FACTOR = 0.7;  // 0.7 Std

let circle = null;
let rectangle = null;
let centerCircle = null;
let map = null;
let diameter = null;
let currentZoomLevel = 12.5; //11
let mapStatus = false;
let token = "GE5UagiJorpH2OH4BpL3";

console.log("-- LEAFLET triggered!!! --")

initializeLeafletMap();

// Initialize the Leaflet map
function initializeLeafletMap() {
  map = L.map('leaflet-content', {
    zoomControl: true,
    scrollWheelZoom: false,
    zoomSnap: 0.01,
    zoomDelta: 0.25,
    smoothWheelZoom: true,
    smoothSensitivity: 2,
    center: coords,
    zoom: currentZoomLevel,
  });

// ALT (MapTiler - Token nötig)
//  const mtLayer = L.maptilerLayer({
//    apiKey: token,
//    style: "topo-v2",
//  }).addTo(map);

// NEU (OpenTopoMap - KOSTENLOS!)
L.tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', {
  maxZoom: 17,
  attribution: '© <a href="https://opentopomap.org">OpenTopoMap</a> | © <a href="https://openstreetmap.org">OSM</a>'
}).addTo(map);

  var geocoder = L.Control.geocoder({
    defaultMarkGeocode: false,
    placeholder: "Suchen...",
  })
    .on('markgeocode', function(e) {
      var newCenter = e.geocode.center
      map.flyTo(newCenter);
    })
    .addTo(map);

  mapStatus = true;
  calculatecutoutShapeLengthAndCreateCircle(map)
  generateURL()

  // Map interactions
  map.on('zoom', handleMapInteractions);
  map.on('zoomend', handleMapInteractions);
  map.on('move', handleMapInteractions);
  map.on('moveend', handleMapInteractions);
}

function handleMapInteractions(event) {
  calculatecutoutShapeLengthAndCreateCircle(map);
  if (event.type === 'zoomend' || event.type === 'moveend') {
    generateURL();
    currentZoomLevel = event.target._zoom;
  }
}

function removeGeometry (geometry) {
  if (geometry) {
    map.removeLayer(geometry);
  }
}

function updateCutoutShape(target, mapSize) {
  if(mapSize.x > mapSize.y) {
    target.style.height = mapSize.y * MAP_SELECTION_FACTOR + "px";
    target.style.width = target.style.height;
  }
  else {
    target.style.width = mapSize.x * MAP_SELECTION_FACTOR + "px";
    target.style.height = target.style.width
  }
}

// Function to calculate the length of the cutoutShape coordinates from left to right and create circle
function calculatecutoutShapeLengthAndCreateCircle(map) {
  if (!mapStatus) {
    console.log("MAP IS NOT ACTIVE!");
    return;
  }
  const mapSize = map.getSize();
  const cutoutShape = document.getElementById('cutoutShape');

  updateCutoutShape(cutoutShape, mapSize)

  // get the diamater
  const cutoutShapeLeft = (mapSize.x - cutoutShape.offsetWidth) / 2;
  const cutoutShapeRight = (mapSize.x + cutoutShape.offsetWidth) / 2;
  const cutoutShapeCenterY = (mapSize.y - cutoutShape.offsetHeight) / 2 + cutoutShape.offsetHeight / 2;

  const leftLatLng = map.containerPointToLatLng([cutoutShapeLeft, cutoutShapeCenterY]);
  const rightLatLng = map.containerPointToLatLng([cutoutShapeRight, cutoutShapeCenterY]);
  diameter = leftLatLng.distanceTo(rightLatLng);

  // Check if new Size is within bounds
  document.getElementById('sidelength').textContent = (diameter / 1000).toFixed(0) + " km";
  const errorMessage = document.getElementById('scale-error-message');
  const btn3D = document.getElementById('btn-3d');
  if((diameter / 1000).toFixed(0) < 3) {
    errorMessage.textContent = "ZOOM OUT";
    btn3D.disabled = true;
    btn3D.style.cursor = 'not-allowed';
    cutoutShape.style.backgroundColor = 'rgba(0, 0, 0, 0.2)';
  }
  else if((diameter / 1000).toFixed(0) > 100) {
    errorMessage.textContent = "ZOOM IN";
    btn3D.disabled = true;
    btn3D.style.cursor = 'not-allowed'
    cutoutShape.style.backgroundColor = 'rgba(0, 0, 0, 0.2)';
  }
  else {
    errorMessage.textContent = "";
    btn3D.disabled = false;
    btn3D.style.cursor = 'pointer'
    cutoutShape.style.backgroundColor = 'transparent';
  }

  removeGeometry(rectangle)

  const center = map.getCenter();
  circle = L.circle(center, {radius: diameter / 2}).addTo(map);
  const circleBounds = circle.getBounds();
  map.removeLayer(circle);
  rectangle = L.rectangle(circleBounds, {color: "transparent", fillColor: "transparent", interactive: false}).addTo(map);
  coords = center;
  

  north = circleBounds.getNorth().toFixed(6)
  east = circleBounds.getEast().toFixed(6)
  south = circleBounds.getSouth().toFixed(6)
  west = circleBounds.getWest().toFixed(6)
  updateCoordsUI()  
}

// Set the height of the cutoutShape to match its width on load and when the window is resized
window.addEventListener('DOMContentLoaded', () => {
  const mapOverlay = document.getElementById('map-overlay');
  const cutoutShape = document.getElementById('cutoutShape');
  cutoutShape.style.height = mapOverlay.offsetWidth + 'px';
  calculatecutoutShapeLengthAndCreateCircle(map);
});

window.addEventListener('resize', () => {
  const mapOverlay = document.getElementById('map-overlay');
  const cutoutShape = document.getElementById('cutoutShape');
  //console.log("window.addEventListener resize TRIGGERED")

  cutoutShape.style.height = mapOverlay.offsetWidth + 'px';
  calculatecutoutShapeLengthAndCreateCircle(map);
});

function updateCoordsUI() {
  document.getElementById('lower-left-lng').value = west;
  document.getElementById('lower-left-lat').value = south;
  document.getElementById('upper-right-lng').value = east;
  document.getElementById('upper-right-lat').value = north;
}